(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-color-swatch"] && !Shopify.designMode) return;
  try {
    
  const injectColorSwatches = () => {
    const wrapper = document.querySelector('#ks-color-swatches-hidden')
    const optionNames = wrapper.dataset.optionNames
  
    document.querySelectorAll('.product-form__input').forEach(productFormInput => {
      formLabel = productFormInput.querySelector('.form__label')

      if (optionNames.includes(formLabel.textContent)) {
        productFormInput.classList.add('ks-color-swatches')
        productFormInput.setAttribute('data-img-circle', wrapper.dataset.imgCircle) 

        formLabel.textContent = productFormInput.querySelector('input:checked').value

        productFormInput.querySelectorAll('label').forEach((label, index) => {
          label.innerHTML = wrapper.querySelector(`img:nth-child(${index + 1})`).outerHTML
        })

        productFormInput.querySelectorAll('input').forEach((input) => {
          input.addEventListener('change', () => {
            productFormInput.querySelector('.form__label').textContent = input.value
          })
        })
      }
    })
  }
  injectColorSwatches()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-image-compare"] && !Shopify.designMode) return;
  try {
     
  class KsImageCompare extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScript()

      setTimeout(() => {
        this.querySelectorAll('[data-image-compare]').forEach(elem => {
          const viewer = new ImageCompare(elem, {
            controlColor: this.dataset.icvControlsColor,
            controlShadow: true,
            addCircle: this.dataset.icvControlsCircle === 'true',
            addCircleBlur: true,
            showLabels: this.dataset.icvShowLabels === 'true',
            labelOptions: {
              before: this.dataset.icvLabelBefore,
              after: this.dataset.icvLabelAfter, 
              onHover: false
            },
            smoothing: this.dataset.icvSmoothing === 'true',
            smoothingAmount: 100,
            hoverStart: this.dataset.icvHoverStart === 'true',
            verticalMode: this.dataset.icvVerticalMode === 'true',
            startingPoint: Number(this.dataset.icvStartingPoint),
            fluidMode: false 
          }).mount()
        })
      }, 500)
    } 

    async injectVendorScript () {
      if (!window.ImageCompare) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/image-compare-viewer@1.5.0/dist/image-compare-viewer.min.js')
        script.setAttribute('integrity', 'sha256-PdMDDNTvcp34lE88wLz1TL/DfpfJNQlj/kbSw2ypzAc=')
        script.setAttribute('crossorigin', 'anonymous')
        document.head.appendChild(script) 
      }
    }
  }
  customElements.define('ks-image-compare', KsImageCompare)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-shop-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = true
      video.play()
    }
  }
}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-sticky-atc"] && !Shopify.designMode) return;
  try {
    
class KsStickyOffer extends HTMLElement {
  constructor() {
    super()
    this.handleVisibility()
    this.handleChooseOffer()
  }

  handleVisibility() {
    const trigger = document.querySelector('product-info')
    if (!trigger) return

    const triggerPoint =
      trigger.getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
      if (window.scrollY > triggerPoint) {
        this.classList.add('show')
        document.body.style.paddingBottom = this.offsetHeight + 'px'
      } else {
        this.classList.remove('show')
        document.body.style.paddingBottom = 0
      }
    })
  }

  handleChooseOffer() {
    const btn = this.querySelector('.ks-choose-offer')
    if (!btn) return

    btn.addEventListener('click', () => {
      const target =
        document.querySelector('[data-bogos-gift]') ||
        document.querySelector('.bogos-gift') ||
        document.querySelector('product-info')

      if (!target) return

      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      target.classList.add('ks-highlight')

      setTimeout(() => {
        target.classList.remove('ks-highlight')
      }, 1200)
    })
  }
}
customElements.define('ks-sticky-offer', KsStickyOffer)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-sticky-image"] && !Shopify.designMode) return;
  try {
    
class KsStickyImage extends HTMLElement {
  constructor () {
    super()

    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight

      const top = this.getBoundingClientRect().top
      const bottom = this.getBoundingClientRect().bottom
      const visibilityTop = Math.round(top / windowHeight * 100)
      const visibilityBottom = Math.round(bottom / windowHeight * 100)

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll('.ks-sticky-image-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * visibilityTop / 100 + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll('.ks-sticky-image-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      }
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }
}
customElements.define('ks-sticky-image', KsStickyImage)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
class KsTestimonialsSlider extends HTMLElement {
  constructor () {
    super()
 
    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    setTimeout(() => { 
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
    }, 500)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

}
customElements.define('ks-testimonials-slider', KsTestimonialsSlider)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-wishlist"] && !Shopify.designMode) return;
  try {
     
  class KsWishlist extends HTMLElement {
    constructor () {
      super ()

      this.localStorageKey = 'ks-wishlist-v2'
      this.products = []

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
      this.querySelector('#KsWishlistDrawer-Overlay').addEventListener('click', this.close.bind(this))
      this.seIconsAccessibility()
      this.fetchProducts()
      
      document.querySelectorAll('.menu-drawer__wishlist').forEach(elem => {
        elem.querySelector('[data-text]').textContent = this.dataset.textIconText
      })

      this.querySelectorAll('.ks-wishlist-btm-clear-all').forEach(btn => {
        btn.addEventListener('click', this.clearAll.bind(this))
      })
    }

    seIconsAccessibility() {
      document.querySelectorAll('.ks-wishlist-icon').forEach(elem => {
        elem.addEventListener('click', (event) => {
          event.preventDefault()
          this.open(elem)
        })
        elem.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault()
            this.open(elem)
          }
        })
      })
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy)

      setTimeout(() => {
        this.classList.add('animate', 'active')
      })

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('KsWishlistDrawer')
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
          trapFocus(containerToTrapFocusOn, focusElement)
        },
        { once: true }
      )

      document.body.classList.add('overflow-hidden')
    }

    close() {
      this.classList.remove('active')
      removeTrapFocus(this.activeElement)
      document.body.classList.remove('overflow-hidden')
    }

    setActiveElement(element) {
      this.activeElement = element
    }

    setProductInLocalStorage (productId, timestamp) {
      let localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
      
      const isWishlisted = localStorageData.some((elem) => elem.id === productId)

      if (isWishlisted) {
        localStorageData = localStorageData.filter((elem) => elem.id !== productId)
      } else {
        localStorageData.unshift({
          id: productId,
          timestamp: timestamp
        })
      }

      localStorageData = localStorageData.slice(0, Number(this.dataset.limit))
      localStorage.setItem(this.localStorageKey, JSON.stringify(localStorageData))
      this.fetchProducts()
    }

    async fetchProducts() {
      if (!this.dataset.accessToken.length) {
        this.querySelector('.ks-wishlist-no-api').removeAttribute('hidden')
        return 
      }

      const query = `
        query getProductsByIds($ids: [ID!]!, $countryCode: CountryCode! $maxWidth: Int, $maxHeight: Int) @inContext(country: $countryCode) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              onlineStoreUrl
              availableForSale
              featuredImage {
                url(transform: { maxWidth: $maxWidth, maxHeight: $maxHeight, crop: CENTER })
                altText
                width
                height
              }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    priceV2 {
                      amount
                      currencyCode
                    }
                    image {
                      url(transform: { maxWidth: $maxWidth, maxHeight: $maxHeight, crop: CENTER })
                      altText
                      width
                      height
                    }
                  }
                }
              }
              metafields(identifiers: [ 
                { namespace: "reviews", key: "rating" },
                { namespace: "reviews", key: "rating_count" }
              ]) {
                key
                value
              }
            }
          }
        }
      ` 

      const localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
      const ids = localStorageData.map(product => `gid://shopify/Product/${product.id}`)

      let imgWidth, imgHeight

      switch (this.dataset.imgRatio) {
        case 'adapt':
          imgWidth = 600
          break
        case 'portrait':
          imgWidth = 480
          imgHeight = 600
          break
        default:
          imgWidth = 600
          imgHeight = 600
      }

      const variables = {
        ids: ids,
        countryCode: this.dataset.countryCode,
        maxWidth: imgWidth, 
        maxHeight: imgHeight
      }

      const response = await fetch(`https://${this.dataset.shopifyDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.dataset.accessToken,
        },
        body: JSON.stringify({ query, variables }),
      })

      // console.log(response)

      const data = await response.json()
      // console.log(data)

      if (data.errors) {
        this.querySelector('.ks-wishlist-no-api').removeAttribute('hidden')
        return 
      }
      
      let products = data.data.nodes
      products = products.filter(product => product !== null)

      products.map(product => {
        product.timestamp = localStorageData.find(elem => product.id.includes(elem.id)).timestamp
        return product
      })
      // console.log(products)

      this.products = products

      this.handleDrawerContents()
    }

    handleDrawerContents () {
      if (this.products.length) {
        this.querySelector('.ks-wishlist-empty').setAttribute('hidden', 'hidden')
        this.classList.remove('is-empty')

        let productList = ''

        this.products.forEach(product => {
          let variantsHTML = ''

          product.variants.edges.forEach(elem => {
            const variant = elem.node
            const id = variant.id.split('/ProductVariant/')[1]
            const title = variant.title
            const price = variant.priceV2.amount.replace('.0', '')
            const currencyCode = variant.priceV2.currencyCode
            const availableForSale = variant.availableForSale
            const img = variant.image.url
            
            variantsHTML += `
              <option 
                value="${id}" ${availableForSale ? '' : 'disabled'}
                data-img="${img}">
                ${title} - ${this.formatPrice(price, currencyCode)}
              </option>
            `
          })

          const productId = product.id.split('/Product/')[1]
          const hasOneVariant = product.variants.edges.length === 1
          const priceVaries = product.priceRange.minVariantPrice.amount !== product.priceRange.maxVariantPrice.amount
          let rating
          let ratingCount
          let ratingDecimal
          
          product.metafields.forEach(metafield => {
            if (metafield && metafield.key === 'rating') {
              rating = JSON.parse(metafield.value)

              ratingDecimal = 0
              let decimal = rating.value % 1
              if (decimal >= 0.3 && decimal <= 0.7) {
                ratingDecimal = 0.5
              } else if ( decimal > 0.7) {
                ratingDecimal = 1
              }
            }
            if (metafield && metafield.key === 'rating_count') {
              ratingCount = Number(metafield.value)
            }
          })

          productList += `
            <div class="ks-wishlist-drawer-product-item" role="listitem">
              <a href="/products/${product.handle}" tabindex="-1">
                <img 
                  src="${product.featuredImage.url}"
                  class="img-fluid" 
                  alt="${product.featuredImage.altText}" 
                  width="600" 
                  height="600"  
                  loading="lazy">
              </a>
              <div class="ks-wishlist-drawer-product-item-center">
                <a href="/products/${product.handle}" class="ks-wishlist-drawer-product-title h4 cart-item__name">
                  ${product.title}
                </a>
                <div class="ks-wishlist-drawer-product-rating" ${rating ? '' : 'hidden'} ${this.dataset.showRating === 'true' ? '' : 'hidden'}>
                  <div class="rating" role="img" aria-label="${rating?.value} out of ${rating?.scale_max} stars">
                    <span 
                      aria-hidden="true" 
                      class="rating-star" 
                      style="
                        --rating: ${Math.floor(rating?.value)}; 
                        --rating-max: ${rating?.scale_max}; 
                        --rating-decimal: ${ratingDecimal};
                      ">
                    </span>
                  </div>
                  <p class="rating-text caption">
                    <span aria-hidden="true">${rating?.value} / ${rating?.scale_max}</span>
                  </p>
                  <p class="rating-count caption">
                    <span aria-hidden="true">(${ratingCount})</span>
                    <span class="visually-hidden">${ratingCount} total reviews</span>
                  </p>
                </div>
                <div 
                  class="
                    ks-wishlist-drawer-product-price price 
                    ${ product.compareAtPriceRange.minVariantPrice.amount === '0.0' ? '' : 'price--on-sale'}
                  ">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textRegularPrice}
                      </span>
                      <span class="price-item price-item--regular">
                        ${priceVaries ? 'From ': ''} 
                        ${this.formatPrice(
                          product.priceRange.minVariantPrice.amount.replace('.0', ''),
                          product.priceRange.minVariantPrice.currencyCode
                        )}
                      </span>
                    </div>
                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textRegularPrice}
                      </span>
                      <span>
                        <s class="price-item price-item--regular">
                          ${this.formatPrice(
                            product.compareAtPriceRange.minVariantPrice.amount.replace('.0', ''),
                            product.compareAtPriceRange.minVariantPrice.currencyCode
                          )}
                        </s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textSalePrice}
                      </span>
                      <span class="price-item price-item--sale price-item--last">
                        ${priceVaries ? 'From ': ''} 
                        ${this.formatPrice(
                          product.priceRange.minVariantPrice.amount.replace('.0', ''),
                          product.priceRange.minVariantPrice.currencyCode
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <product-form ${this.dataset.showAtcForm === 'true' ? '' : 'hidden'}>
                  <form method="post" 
                    action="${this.dataset.routesCartAdd}" 
                    accept-charset="UTF-8" 
                    class="ks-wishlist-drawer-product-form form" 
                    enctype="multipart/form-data" 
                    novalidate="novalidate" 
                    data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="product-id" value="${productId}">
                    <div class="field-wrapper" ${hasOneVariant ? 'hidden' : ''}>
                      <div class="ks-wishlist-drawer-product-select select">
                        <select 
                          name="id" 
                          class="select__select"
                          aria-label="Select variant">
                            ${variantsHTML}
                        </select>
                        <span class="svg-wrapper">
                          <svg class="icon icon-caret" viewBox="0 0 10 6">
                            <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>
                            </svg>
                        </span>
                      </div>
                    </div>
                    <button 
                      type="submit" 
                      name="add" 
                      class="ks-wishlist-drawer-product-btn button button--full-width ${this.dataset.btnStyle}"
                      aria-haspopup="dialog"
                      ${product.availableForSale ? '' : 'disabled'}>
                      <span>
                        ${product.availableForSale ? this.dataset.textAddToCart : this.dataset.textSoldOut}
                      </span>
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                      </div>
                    </button>
                  </form>
                </product-form>
                <div class="ks-wishlist-drawer-product-bottom">
                   <p class="ks-wishlist-drawer-product-timestamp" ${this.dataset.showTimestamp === 'true' ? '' : 'hidden'}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    ${this.handleTimestamp(product.timestamp)}
                  </p>
                  <a 
                    href="javascript:void(0)" 
                    class="ks-wishlist-drawer-product-remove" 
                    data-product-id="${productId}">
                    ${this.dataset.textProductRemove}
                  </a>
                </div>
              </div>
            </div>
          `
        })

        this.querySelector('.ks-wishlist-drawer-product-list-wrapper').removeAttribute('hidden')
        this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = productList

        this.querySelectorAll('.ks-wishlist-drawer-product-item select[name="id"]').forEach(select => {
          select.addEventListener('change', (event) => this.onVariantChange(select, event))
        })

        this.querySelectorAll('.ks-wishlist-drawer-product-item button[name="add"]').forEach(btn => {
          btn.addEventListener('click', () => {
            setTimeout(() => {
              this.close()
            }, 400)
          })
        })

        this.querySelectorAll('.ks-wishlist-drawer-product-remove').forEach(btn => {
          btn.addEventListener('click', (event) => {
            event.preventDefault()
            
            let localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
            localStorageData = localStorageData.filter((elem) => elem.id !== Number(btn.dataset.productId))
            localStorage.setItem(this.localStorageKey, JSON.stringify(localStorageData))
            this.fetchProducts()

            document.querySelectorAll('.ks-wishlist-btn').forEach(elem => {
              elem.adjustBtn()
            })
          })
        })

      } else {
        this.querySelector('.ks-wishlist-empty').removeAttribute('hidden')
        this.classList.add('is-empty')
        this.querySelector('.ks-wishlist-drawer-product-list-wrapper').setAttribute('hidden', 'hidden')
        this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = ''
      }

      this.setCountBubles()
    }

    clearAll() {
      this.products = []
      localStorage.removeItem(this.localStorageKey)
      this.handleDrawerContents()
      // this.close()

      document.querySelectorAll('.ks-wishlist-btn').forEach(elem => {
        elem.adjustBtn()
      })
    }

    formatPrice(amount, currencyCode) {
      const currencySymbols = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        JPY: '¥',
        AUD: 'A$',
        CAD: 'C$'
      }
      const symbol = currencySymbols[currencyCode] || currencyCode;
      return `${symbol}${amount}`
    }
    
    onVariantChange (select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.img

      if (imgSrc) {
        const img = select.closest('.ks-wishlist-drawer-product-item').querySelector('img')
        img.src = imgSrc
      }
    }
    
    handleTimestamp(timestamp) {
      const now = Date.now()
      const secondsAgo = Math.floor((now - timestamp * 1000) / 1000)

      if (secondsAgo < 60) return this.dataset.textMomentsAgo
      if (secondsAgo < 3600) return `${Math.floor(secondsAgo / 60)} ${this.dataset.textMinAgo}`
      if (secondsAgo < 86400) return `${Math.floor(secondsAgo / 3600)} ${this.dataset.textHoursAgo}`
      if (secondsAgo < 604800) return `${Math.floor(secondsAgo / 86400)} ${this.dataset.textDaysAgo}`

      const date = new Date(timestamp * 1000)
      return `${date.toLocaleDateString()}`
    }

    setCountBubles () {
      document.querySelectorAll('.ks-wishlist-icon').forEach(elem => {
        elem.querySelectorAll('[data-ks-count-text]').forEach(elem2 => {
          elem2.textContent = this.products.length

          elem2.closest('.ks-wishlist-count-bubble')?.setAttribute('data-ks-count', this.products.length)
        })
      })
    }
  }
  customElements.define('ks-wishlist-drawer', KsWishlist)

  class KsWishlistBtn extends HTMLElement {
    constructor () {
      super()

      this.btn = this.querySelector('button')
      this.wishlistDrawer = document.querySelector('ks-wishlist-drawer')

      this.adjustBtn()

      this.btn.addEventListener('click', async (event) => {
        event.preventDefault()

        this.wishlistDrawer.setProductInLocalStorage(
          Number(this.dataset.productId),
          Number(this.dataset.timestamp)
        )

        this.adjustBtn()
      })
    }

    adjustBtn () {
      const localStorageData = JSON.parse(localStorage.getItem(this.wishlistDrawer.localStorageKey)) || []
      const isWishlisted = localStorageData.some((elem) => elem.id === Number(this.dataset.productId))

      if (isWishlisted) {
        this.btn.classList.add('active')
        this.btn.setAttribute('aria-label', this.dataset.textRemove)
        this.btn.setAttribute('aria-pressed', 'true')
      } else {
        this.btn.classList.remove('active')
        this.btn.setAttribute('aria-label', this.dataset.textAdd)
        this.btn.setAttribute('aria-pressed', 'false')
      }
    }
  }
  customElements.define('ks-wishlist-btn', KsWishlistBtn)

  } catch(e) { console.error(e); }
})();
})();
